import { render } from "./LabelComponent.vue?vue&type=template&id=d5a8e6d6&ts=true"
import script from "./LabelComponent.vue?vue&type=script&lang=ts"
export * from "./LabelComponent.vue?vue&type=script&lang=ts"

import "./LabelComponent.vue?vue&type=style&index=0&id=d5a8e6d6&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__